export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";